const MUTATOR_TYPES = {
  INCIDENT: 'incident',
  ENTITY: 'entity',
};

export default MUTATOR_TYPES;
